import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteSubsidiaryCategoryModel, SortSubsidiaryCategoryModel} from '../Model'
import {SubsidiaryCategoryModel} from '../Model/SubsidiaryCategoryModel'
import {actionTypes} from './constants'
export const actions = {
  // get SubsidiaryCategory
  getAllSubsidiaryCategory: () => ({
    type: actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_START,
  }),
  getAllSubsidiaryCategorySuccess: (data: SubsidiaryCategoryModel) => ({
    type: actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: data,
  }),
  getAllSubsidiaryCategoryFinish: () => ({
    type: actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_FINISH,
  }),

  // get SubsidiaryCategory DATA
  getSubsidiaryCategory: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_SUBSIDIARY_CATEGORY_START,
    payload: params,
  }),
  getSubsidiaryCategorySuccess: (data: SubsidiaryCategoryModel) => ({
    type: actionTypes.GET_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: data,
  }),
  getSubsidiaryCategoryFinish: () => ({
    type: actionTypes.GET_SUBSIDIARY_CATEGORY_FINISH,
  }),

  // create key
  addSubsidiaryCategory: (data: SubsidiaryCategoryModel) => ({
    type: actionTypes.ADD_SUBSIDIARY_CATEGORY_START,
    payload: data,
  }),
  addSubsidiaryCategorySuccess: (task: any) => ({
    type: actionTypes.ADD_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: task,
  }),
  addSubsidiaryCategoryFinish: () => ({
    type: actionTypes.ADD_SUBSIDIARY_CATEGORY_FINISH,
  }),
  resetSubsidiaryCategory: () => ({
    type: actionTypes.RESET_SUBSIDIARY_CATEGORY,
  }),

  //Update SubsidiaryCategory
  updateSubsidiaryCategory: (data: SubsidiaryCategoryModel, id: string) => ({
    type: actionTypes.UPDATE_SUBSIDIARY_CATEGORY_START,
    payload: data,
    id,
  }),

  updateSubsidiaryCategorySuccess: (data: SubsidiaryCategoryModel) => ({
    type: actionTypes.UPDATE_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: data,
  }),

  updateSubsidiaryCategoryFinish: () => ({
    type: actionTypes.UPDATE_SUBSIDIARY_CATEGORY_FINISH,
  }),

  // delete key
  deleteSubsidiaryCategory: (data: DeleteSubsidiaryCategoryModel[]) => ({
    type: actionTypes.DELETE_SUBSIDIARY_CATEGORY_START,
    payload: {subsidiaryCategoryId: data},
  }),
  deleteSubsidiaryCategorySuccess: (data: any) => ({
    type: actionTypes.DELETE_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: data,
  }),
  deleteSubsidiaryCategoryFinish: () => ({
    type: actionTypes.DELETE_SUBSIDIARY_CATEGORY_FINISH,
  }),

  //Enable SubsidiaryCategory
  enableSubsidiaryCategory: (data: any) => ({
    type: actionTypes.ENABLE_SUBSIDIARY_CATEGORY_REQUEST,
    payload: {data},
  }),

  enableSubsidiaryCategorySuccess: (task: any) => ({
    type: actionTypes.ENABLE_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: task,
  }),
  enableSubsidiaryCategoryFinish: () => ({
    type: actionTypes.ENABLE_SUBSIDIARY_CATEGORY_FINISH,
  }),

  //Disable SubsidiaryCategory
  disableSubsidiaryCategory: (data: any) => ({
    type: actionTypes.DISABLE_SUBSIDIARY_CATEGORY_REQUEST,
    payload: {data},
  }),

  disableSubsidiaryCategorySuccess: (task: any) => ({
    type: actionTypes.DISABLE_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: task,
  }),
  disableSubsidiaryCategoryFinish: () => ({
    type: actionTypes.DISABLE_SUBSIDIARY_CATEGORY_FINISH,
  }),

  //Enable SubsidiaryCategory
  singleEnableSubsidiaryCategory: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_REQUEST,
    payload: {data},
  }),

  singleEnableSubsidiaryCategorySuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: task,
  }),
  singleEnableSubsidiaryCategoryFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_FINISH,
  }),

  //Disable SubsidiaryCategory
  singleDisableSubsidiaryCategory: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_REQUEST,
    payload: {data},
  }),

  singleDisableSubsidiaryCategorySuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: task,
  }),
  singleDisableSubsidiaryCategoryFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_FINISH,
  }),

  
  // sort
  sortSubsidiaryCategory: (data: SortSubsidiaryCategoryModel) => ({
    type: actionTypes.SORT_SUBSIDIARY_CATEGORY_START,
    payload: data,
  }),
  sortSubsidiaryCategorySuccess: (data: Array<SubsidiaryCategoryModel>) => ({
    type: actionTypes.SORT_SUBSIDIARY_CATEGORY_SUCCESS,
    payload: data,
  }),
  sortSubsidiaryCategoryFinish: () => ({
    type: actionTypes.SORT_SUBSIDIARY_CATEGORY_FINISH,
  }),
  sortSubsidiaryCategoryReset: () => ({
    type: actionTypes.SORT_SUBSIDIARY_CATEGORY_RESET,
  }),
}
